import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

export const FamilyEvent: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Family Event"
      description="Create lasting memories with our family event services. We specialize in organizing family gatherings, reunions, and celebrations that bring everyone together."
      features={["Family-friendly environment", "Customizable event packages", "Entertainment for all ages", "Special family menus"]}
      images={["/images/facilities/family-lounge.jpg"]}
    />
  );
};

export const FilmshootEvent: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Filmshoot Event"
      description="Our venue provides the perfect backdrop for film shoots and media productions. With versatile spaces and professional support, we cater to all your filming needs."
      features={["Versatile shooting locations", "Professional lighting support", "Equipment-friendly setup", "Flexible timing"]}
      images={["/images/about1.jpg"]}
    />
  );
};

export const FilmshootParty: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Filmshoot Party"
      description="Celebrate your film wrap-ups and production milestones with our specialized filmshoot party services. Perfect for cast and crew celebrations."
      features={["Industry-friendly atmosphere", "Flexible party packages", "Professional service", "Entertainment options"]}
      images={["/images/about2.jpg"]}
    />
  );
};

export const KittyParty: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Kitty Party"
      description="Host your kitty party in style with our specially designed packages for ladies' gatherings. Enjoy great food, drinks, and entertainment in a comfortable setting."
      features={["Ladies-only sections available", "Special kitty party menus", "Entertainment options", "Comfortable seating arrangements"]}
      images={["/images/facilities/family-lounge.jpg"]}
    />
  );
};

export const PreweddingShoot: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Prewedding Shoot"
      description="Capture your love story with our beautiful venue as the backdrop for your prewedding photoshoot. We provide the perfect romantic setting for your special moments."
      features={["Romantic ambiance", "Multiple photo locations", "Professional lighting", "Flexible timing slots"]}
      images={["/images/about1.jpg"]}
    />
  );
};

export const FamilyParties: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Family Parties"
      description="Celebrate family milestones and special occasions with our comprehensive family party services. From anniversaries to graduations, we make every celebration special."
      features={["All-age entertainment", "Customizable decorations", "Family-style dining", "Special occasion packages"]}
      images={["/images/facilities/family-lounge.jpg"]}
    />
  );
};